'use client'

import React, { Component } from 'react'
import FlightIcon from '@hashicorp/react-hds/src/components/flight-icon'
import { Button } from '@hashicorp/react-mds/src/components/button'
import Tippy from '@tippy.js/react'
import s from './style.module.css'

// Feature Table
// -------------
// Component specifically for the "Become A Partner" page, which renders a table
// with multiple tabs, rows and columns
//
// Used on pages:
// - Become A Partner

export default class FeatureTable extends Component {
	constructor(props) {
		super(props)
		this.state = { tabIdx: 0 }
		this.selectTab = this.selectTab.bind(this)
	}

	selectTab(e) {
		if (e.target.dataset.idx === this.state.tabIdx) return
		this.setState({ tabIdx: e.target.dataset.idx })
	}

	render() {
		const { tableContent } = this.props
		const tab = tableContent.tabs[this.state.tabIdx]

		const tabButtons = (
			<div className={s.tabSelect}>
				{tableContent.tabs.map((tab, i) => (
					<div
						key={tab.id}
						className={`${s.tab} ${this.state.tabIdx == i ? s.active : ''}`}
						onClick={this.selectTab}
						data-idx={i}
					>
						{tab.title}
					</div>
				))}
			</div>
		)
		return (
			<div className={s.root} data-state={this.props._state}>
				<table>
					<thead>
						<tr>
							<th>{tabButtons}</th>
							{tab.columns.map((c, i) => (
								// This array is stable, so we can use index as key
								// eslint-disable-next-line react/no-array-index-key
								<th key={i}>{c.title}</th>
							))}
							{!tab.columns.length ? <td /> : ''}
						</tr>
					</thead>
					<tbody>
						{tab.rows.map((r) => (
							<tr key={r.id}>
								<td>
									{r.title}
									{r.tooltip && (
										<Tippy content={r.tooltip}>
											<span>
												<FlightIcon name="help" color="#B4B8BC" />
											</span>
										</Tippy>
									)}
								</td>
								{tab.columns.map((c, stableIdx) => {
									let columnVal = r.columnValues.find((value) => {
										return value.column.id === c.id
									})
									let desc = columnVal && columnVal.description

									return (
										// This array is stable, so we can use index as key
										// eslint-disable-next-line react/no-array-index-key
										<td key={stableIdx}>
											{desc ||
												(columnVal && (
													<FlightIcon
														name="check-circle-fill"
														color="var(--token-color-foreground-success)"
														size={24}
													/>
												))}
										</td>
									)
								})}
								{!tab.columns.length ? <td /> : ''}
							</tr>
						))}
						<tr>
							<td />
							{tab.columns.map((c, stableIdx) =>
								// This array is stable, so we can use index as key
								// eslint-disable-next-line react/no-array-index-key
								stableIdx < tab.columns.length - 1 ? <td key={stableIdx} /> : ''
							)}
							<th>
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<Button
										theme={{
											variant: 'primary',
										}}
										{...tableContent.applyLink}
									/>
								</div>
							</th>
						</tr>
					</tbody>
				</table>
			</div>
		)
	}
}
